import styled from 'styled-components';
import Intro from 'gatsby-theme-forms/src/components/intro';

export default styled(Intro)`
  margin-top: 1rem;
`;
